<template>
    <div>
        <v-card flat v-if="$route.params.id && interview.created_at">
            <v-card-title>Durchgeführt am {{interview.created_at}} durch {{interview.interviewer}}</v-card-title>
        </v-card>
        <v-card flat v-else>
            <!--Date interviewed sets created_at-->
            <v-card-text>
                <v-checkbox label="Benutzerdefiniertes Datum der Durchführung / Gespräch hat nicht heute stattgefunden" v-model="customDate" :false-value="false" :true-value="true" @change="interview.created_at = false"></v-checkbox>
                <v-menu
                        v-model="dateMenu"
                        ref="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        :nudge-right="40"
                        offset-y
                        min-width="290px"
                        :disabled="!customDate"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                :value="createdFormatted"
                                label="Datum der Durchführung"
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                readonly
                                outlined
                                :disabled="!customDate"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="interview.created_at" no-title scrollable locale="de" @input="dateMenu = false"/>
                </v-menu>
            </v-card-text>
        </v-card>
        <v-form>
            <v-tabs>
                <v-tab class="primary--text">Zusammenfassung</v-tab>
                <v-tab class="primary--text" v-if="($can('show risk own') || $can('show risk employee') || $can('show interview')) && ((queryType === 'employee' || queryType === 'hr-department') || creating) ">Risikobewertung</v-tab>

                <!--Conclusion-->
                <v-tab-item eager>
                    <v-card outlined flat color="secondary" class="mt-5" style="position: sticky; width: 100%; top: 72px; z-index: 1;" v-if="($can('create interview employee') || $can('update interview employee')) && ((queryType === 'employee') || creating)">
                        <v-card-title class="py-2">

                            <v-btn color="primary" text v-if="interview.id && readonly" @click="readonly = !readonly">Bearbeiten<v-icon>mdi-pencil</v-icon></v-btn>
                            <v-btn color="success" depressed v-else-if="interview.id && !readonly" @click="updateInterview">Speichern<v-icon>mdi-content-save-outline</v-icon></v-btn>

                            <!--store button-->
                            <v-tooltip top v-else :disabled="!!interview.interviewed_id">
                                <template v-slot:activator="{ on }" >
                                    <span v-on="on">
                                        <v-btn
                                                color="success"
                                                depressed
                                                :disabled="!interview.interviewed_id"
                                                @click="storeInterview"
                                        >
                                            Speichern<v-icon>mdi-content-save-outline</v-icon>
                                        </v-btn>
                                    </span>

                                </template>
                                <span>Wählen Sie zunächst einen Mitarbeiter aus.</span>
                            </v-tooltip>

                            <v-spacer/>

                            <!--release conclusion button-->
                            <v-tooltip top v-if="!conclusion.is_released" :disabled="!!interview.id">
                                <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                        <v-dialog v-model="releaseConclusionDialog" persistent max-width="500">
                                            <template v-slot:activator="{ on, attrs}">
                                            <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    color="primary"
                                                    depressed
                                                    :disabled="!interview.id"
                                            >
                                                Zusammenfassung freigeben <v-icon>mdi-share-variant</v-icon>
                                            </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title style="word-break: normal">
                                                    Sind Sie sich sicher, dass Sie die Zusammenfassung mit den aktuellen Änderungen freigeben wollen?
                                                </v-card-title>
                                                <v-card-text>
                                                    Mit der Freigabe wird das Gespräch für den Mitarbeiter sichtbar, die Zusammenfassung einsehbar und der Mitarbeiter wird bei Änderungen per E-Mail benachrichtigt.
                                                </v-card-text>
                                                <v-card-subtitle class="font-italic">
                                                    Hinweis: Die Risikobewertung wird weiterhin nicht für den Mitarbeiter einsehbar sein.
                                                </v-card-subtitle>
                                                <v-card-actions>
                                                    <v-spacer/>
                                                    <v-btn color="error" outlined @click="releaseConclusionDialog = false">Abbrechen</v-btn>
                                                    <v-btn color="success" depressed @click="conclusion.is_released = true; updateInterview();">Zusammenfassung freigeben</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </span>

                                </template>
                                <span >Das Gespräch muss zunächst gespeichert werden.</span>
                            </v-tooltip>
                            <v-btn color="primary" depressed disabled v-else >Zusammenfassung ist freigegeben <v-icon>mdi-share-variant</v-icon></v-btn>
                        </v-card-title>
                    </v-card>
                    <EmployeeInterviewsUtilityFormConclusion v-on:pass="conclusion = $event" v-on:toAdvancement="advancement = $event" v-on:reload="showInterview" :payload="conclusion" :advancement="advancement" :readonly="readonly"/>
                </v-tab-item>


                <!--Risk-->
                <v-tab-item eager v-if="($can('show risk own') || $can('show risk employee') || $can('show interview')) && ((queryType === 'employee' || queryType === 'hr-department') || creating)">
                    <v-card color="secondary" flat class="mt-5" style="position: sticky; width: 100%; top: 72px; z-index: 1;" v-if="($can('create interview employee') || $can('update interview employee')) && ((queryType === 'employee') || creating)">
                        <v-card-title class="py-2">
                            <v-btn color="primary" text v-if="interview.id && readonly" @click="readonly = !readonly">Bearbeiten<v-icon>mdi-pencil</v-icon></v-btn>
                            <v-btn color="success" depressed v-else-if="interview.id && !readonly" @click="updateInterview">Speichern<v-icon>mdi-content-save-outline</v-icon></v-btn>

                            <!--store button-->
                            <v-tooltip top v-else :disabled="!!interview.interviewed_id">
                                <template v-slot:activator="{ on }" >
                                    <span v-on="on">
                                        <v-btn
                                                color="success"
                                                depressed
                                                :disabled="!interview.interviewed_id"
                                                @click="storeInterview"
                                        >
                                            Speichern<v-icon>mdi-content-save-outline</v-icon>
                                        </v-btn>
                                    </span>

                                </template>
                                <span>Wählen Sie zunächst einen Mitarbeiter aus.</span>
                            </v-tooltip>

                            <v-spacer/>

                            <!--release risk button-->
                            <v-tooltip top v-if="!risk.is_released" :disabled="!!interview.id">
                                <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                        <v-dialog v-model="releaseRiskDialog" persistent max-width="500">
                                            <template v-slot:activator="{ on, attrs}">
                                            <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    color="primary"
                                                    depressed
                                                    :disabled="!interview.id"
                                            >
                                                Risikobewertung freigeben <v-icon>mdi-share-variant</v-icon>
                                            </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title style="word-break: normal">
                                                    Sind Sie sich sicher, dass Sie die Risikobewertung mit den aktuellen Änderungen freigeben wollen?
                                                </v-card-title>
                                                <v-card-subtitle class="font-italic">
                                                    Hinweis: Die Risikobewertung wird weiterhin nicht für den Mitarbeiter einsehbar sein.
                                                </v-card-subtitle>
                                                <v-card-actions>
                                                    <v-spacer/>
                                                    <v-btn color="error" outlined @click="releaseRiskDialog = false">Abbrechen</v-btn>
                                                    <v-btn color="success" depressed @click="risk.is_released = true; updateInterview();">Risikobewertung freigeben</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </span>

                                </template>
                                <span >Das Gespräch muss zunächst gespeichert werden.</span>
                            </v-tooltip>
                            <v-btn color="primary" depressed disabled v-else >Risikobewertung ist freigegeben <v-icon>mdi-share-variant</v-icon></v-btn>
                        </v-card-title>
                    </v-card>
                    <EmployeeInterviewsUtilityFormRisk v-on:pass="risk = $event" :payload="risk" :readonly="readonly"/>
                </v-tab-item>
            </v-tabs>
            <v-card-text v-if="$can('delete interview employee') && interview.id && queryType === 'employee'" >
                <v-row no-gutters>
                    <v-col cols="12" md="12">
                        <v-dialog v-model="deleteDialog" persistent max-width="400">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        block
                                        color="error"
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                >Mitarbeitergespräch löschen<v-icon>mdi-delete-outline</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title style="word-break: normal">
                                    Sind Sie sich sicher, dass Sie das Mitarbeitergespräch löschen wollen?
                                </v-card-title>
                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn color="success" outlined @click="deleteDialog = false">Abbrechen</v-btn>
                                    <v-btn color="error" depressed @click="deleteInterview">Löschen</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>
            </v-card-text>

        </v-form>
    </div>
</template>

<script>
    export default {
        props: ['interviewed_id_prob'],
        data: () => ({
            releaseConclusionDialog: false,
            releaseRiskDialog: false,
            deleteDialog: false,
            customDate: false,
            dateMenu: false,
            interviewed: {},
            readonly: false,
            interview: {
                interviewed_id: false,
                created_at: null,
            },
            conclusion: {
            },
            risk: {

            },
            advancement: {
                plans: '',
                actions_type: '',
                actions_responsible: '',
                note: '',
            },
            type: '',

        }),
        watch: {
            interviewed_id_prob: function (val) {
                this.interview.interviewed_id = val;
            }
        },
        computed: {
            createdFormatted(){
                return this.interview.created_at ? this.$moment(this.interview.created_at).format('DD.MM.YYYY') : '';
            },
            queryType(){
                return this.$route.query.type;
            },
            creating(){
                return [
                    'EmployeeInterviewsCreate',
                ].includes(this.$route.name);
            }
        },
        created() {
            if (this.$route.params.id){
                this.readonly = true;
            }
            this.showInterview();
        },
        methods: {
            storeInterview(){
                this.interview.interviewed_id = this.interviewed_id_prob;
                this.axios.post('/interviews', {
                    'interview' : this.interview,
                    'risk' : this.risk,
                    'conclusion' : this.conclusion,
                    'advancement' : this.advancement,
                }).then( (response) =>{
                    this.$toast.success('Das Mitarbeitergespräch wurde erfolgreich angelegt.');
                    this.$router.push({ name: 'EmployeeInterviewsEdit', params: { id: response.data }, query: {type: 'employee'}});
                }).catch( () => {
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.')
                });
            },
            showInterview(){
                if (this.$route.params.id){
                    this.axios.get('/interviews/'+this.$route.params.id + '?type=' + this.$route.query.type).then((response) => {
                        const resp = response.data.data;
                        this.interview = resp;
                        this.conclusion = resp.conclusion;
                        if (this.queryType === 'employee' || this.queryType === 'hr-department'){
                            this.risk = resp.risk;
                        }
                        this.interviewed = {...resp.interviewed};
                        this.conclusion.advancements = Object.values({...resp.conclusion.advancements});
                        this.type = resp.type;

                        this.advancement.plans = '';
                        this.advancement.actions_type = '';
                        this.advancement.actions_responsible = '';
                        this.advancement.note = '';

                        this.$emit('getUser', this.interviewed)
                    }).catch( (e) => {
                        if(e.response.status === 401){
                            this.$toast.error('Sie sind nicht dazu berechtigt sich dieses Mitarbeitergespräch anzusehen.');
                            this.$router.push({ name: 'EmployeeInterviewsDashboard'});
                        }
                        else{
                            this.$toast.error('Ein Fehler ist aufgetreten, oder das Mitarbeitergespräch wurde gelöscht.');
                            this.$router.push({ name: 'EmployeeInterviewsDashboard'});
                        }

                    })
                }
            },
            updateInterview(){
                this.readonly = true;
                this.axios.patch('/interviews/' + this.interview.id, {
                    'interview' : this.interview,
                    'risk' : this.risk,
                    'conclusion' : this.conclusion,
                    'advancement' : this.advancement,
                }).then( () =>{
                    this.$toast.success('Das Mitarbeitergespräch wurde erfolgreich aktualisiert.');
                    this.showInterview();
                }).catch( () => {
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.')
                });
            },
            deleteInterview(){
                this.axios.delete('/interviews/' + this.interview.id).then( () =>{
                    this.$toast.success('Das Mitarbeitergespräch wurde erfolgreich gelöscht.');
                    this.$router.push({ name: 'EmployeeInterviewsDashboard'});
                }).catch( () => {
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.')
                });
            }
        }
    }
</script>

<style scoped>

</style>
